<script>
export default {
    name: 'ServicePlanFeatureScope',
};
</script>

<script setup>
import { computed, toRef } from 'vue';
import i18n from '@/plugins/i18n.ts';
import formatNumber from '@/utils/format-number.ts';
import { FIELD, FORMAT } from '@/components/payments/components/service-plan/components/features/constants';
import useFeature from '@/components/payments/components/service-plan/components/features/composables/use-feature';
import ServicePlanFeatureElementsValue from '@/components/payments/components/service-plan/components/features/components/elements/value';
import formatList from '@/utils/format-list.ts';

const props = defineProps({
    feature: {
        type: Object,
        required: true,
    },
});

const { value, count, format } = useFeature(toRef(props, 'feature'));

const valueList = computed(() => {
    if (Array.isArray(value.value)) return value.value;
    if (value.value) return [value.value];

    return [];
});

const formatted = computed(() => {
    if (format.value === FORMAT.FIXED) {
        return i18n.tc('payment.servicePlan.feature.scope.specific', valueList.value.length, {
            id: formatList(valueList.value.map(id => `#${id}`)),
        });
    }

    if (format.value === FORMAT.DYNAMIC && count.value !== null && count.value !== undefined) {
        const available = Math.max(count.value - valueList.value.length, 0);

        return i18n.tc('payment.servicePlan.feature.scope.available', available, {
            available: formatNumber(available, true),
            count: formatNumber(count.value, true),
        });
    }

    return i18n.t('payment.servicePlan.feature.scope.all');
});
</script>

<template>
    <service-plan-feature-elements-value
        :name="feature[FIELD.NAME]"
        :value="formatted"
    />
</template>
